import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import type { Option } from "@/domain/types/option";

const POSITIONS = [
  { value: "Administrador", key: "common.representatives.positions.administrator" },
  { value: "Consejero delegado", key: "common.representatives.positions.chief_executive" },
  { value: "Apoderado", key: "common.representatives.positions.authorized_representative" },
];

export function usePositionOptions(): Option[] {
  const { t } = useTranslation();
  return useMemo(
    () => POSITIONS.map((position) => ({ value: position.value, label: t(position.key) })),
    [t],
  );
}
